<template>
    <div>
        <div class="card">
            <div class="body">
                <div class="alert alert-info d-inline-block"
                    v-if="this.$Params.authenticator == 2 && userModel.authenticator == '0'">
                    <b>Atención!</b> Debes activar la autenticación de doble factor, para poder seguir utilizando el
                    portal.
                </div>
                <div class="row">
                    <div class="col-md-6 col-xs-12">
                        <p>{{ $t('configurationPageInfo') }}</p>
                        <div class="form-group">
                            <label>{{ $t('selectLanguage') }}</label>
                            <select id="select-languages" v-model="userModel.language" class="form-control">
                                <option v-for="lng in languages" v-bind:key="lng.id" v-bind:value="lng.id">{{ lng.desc
                                    }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>{{ $t('adDays1') }} (<i class="ms-Icon ms-Icon--FavoriteStarFill"
                                    style="color: #EE802F;"></i>) {{ $t('adDays2') }}</label>
                            <input id="numDias" type="text" maxlength="2" class="form-control"
                                v-model="userModel.numDias">
                        </div>
                        <div class="form-group" v-if="this.$Params.authenticator != 0">
                            <div class="checkbox">
                                <input id="cbAuthenticator" type="checkbox" true-value="1" false-value="0"
                                    name="cbAuthenticator" v-model="userModel.authenticator">
                                <label for="cbAuthenticator">{{ $t('autenticacion2Pasos') }}</label>
                            </div>
                        </div>
                        <div class="form-group" v-if="userModel.authenticator == '1'">
                            <img :src="imgQr" class="float-left" style="max-width:240px" />
                            <p class="pt-3">{{ $t('generatedCode') }} <br><b>{{ codeAuthenticator }}</b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <a href="#" @click.prevent="updateDataUser"
                    class="btn btn-primary waves-effect waves-light btn-submit-success validate-tab validate-loading">{{
                    $t('save') }}</a>
            </div>
        </div>
        <ModalAuthenticator ref="authenticator" @getCode="getCodeAuthenticator" />
    </div>
</template>

<script>
import ModalAuthenticator from '@/components/ModalAuthenticator.vue'
import { userService } from '@/api/user';
import { localize } from "vee-validate";
import { langValidate } from '@/_helpers/lang/localize';
import { languageUtil } from '@/_utils/languageUtil';

export default {
    name: 'UserConfiguration',
    components: {
        ModalAuthenticator
    },
    data() {
        return {
            userModel: {
                authenticator: '0',
                language: '',
                numDias: 0,
                code: ''
            },
            languages: [],
            codeAuthenticator: '',
            imgQr: '',
            originalMfa: '0'
        }
    },
    methods: {
        updateDataUser() {
            if (this.originalMfa != this.userModel.authenticator) {
                this.$refs.authenticator.openModal();
            }
            else {
                this.submitData();
            }
        },
        getCodeAuthenticator(data) {
            this.userModel.code = data.code;
            this.submitData();
        },
        async submitData() {
            if (this.userModel.language !== this.$i18n.locale) {
                if (this.userModel.language == "")
                    this.userModel.language = 'es';
                this.$i18n.locale = this.userModel.language;
                localize(this.userModel.language, langValidate[this.userModel.language]);
                localStorage.setItem('lang-active-pdoc', this.userModel.language);
            }

            if (await userService.updateUserData(this.userModel)) {
                this.$Params.user_authenticator = this.userModel.authenticator;
                if (this.userModel.authenticator) this.$Params.requires_authenticator = '0';
            }
        }
    },
    async mounted() {

        this.languages = languageUtil.getLanguages();

        let userData = await userService.userData();
        this.userModel.language = userData.language;
        this.userModel.numDias = userData.numDias;
        this.userModel.authenticator = userData.authenticator;
        this.originalMfa = userData.authenticator;

        if (this.$Params.authenticator != '0') { 
            let userAuthenticator = await userService.userAuthenticator();
            this.codeAuthenticator = userAuthenticator.text;
            this.imgQr = userAuthenticator.imgQr;
        }
    }
}
</script>